import StarIcon from "assets/icons/star-fill.svg";
import styled from "styled-components";
import { theme } from "styles/theme";

const StyledHeaderIsVerified = styled.div`
  height: 100%;
  .header__profile {
    display: flex;
    height: 100%;
    &-info {
      display: flex;
      .avt {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-left: 15px;
        justify-content: center;
        padding-right: 20px;
        .avatar-user {
          position: relative;
          display: block;
          width: 38px;
          height: 38px;
          background-color: ${theme.colors.secondary[50]};
          border-radius: 50%;
          border: 2px solid #7e3b32;
          img {
            width: 100%;
            height: 100%;
            border-radius: 100%;
            -o-object-fit: contain;
            object-fit: contain;
            z-index: 10;
          }
        }
        a {
          font-size: 12px;
          color: ${theme.colors.secondary[900]};
          text-transform: uppercase;
          font-weight: 500;
          text-decoration: none;
        }
      }
      .bag {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-evenly;
        .mess {
          display: flex;
          align-items: center;
          .name {
            font-weight: 700;
            font-size: 14px;
            line-height: 12px;
            color: rgb(248, 160, 26);
            text-transform: uppercase;
            margin-right: 8px;
          }
          .status {
            font-size: 10px;
            font-weight: 700;
            color: #333;
            a {
              text-decoration: none;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 16px;
              min-width: 16px;
              background-color: #fde410;
              border-radius: 8px;
              padding-left: 5px;
              padding-right: 5px;
              .user-info__messages-title {
                position: relative;
                overflow: hidden;
                background: #ed6565;
                border-radius: 8px;
                height: 16px;
                line-height: 16px;
                padding: 0 4px;
                font-size: 10px;
                color: #fff;
                font-weight: 700;
                margin-left: 3px;
                margin-right: -5px;
              }
              .empty {
                background: ${theme.colors.secondary[900]};
              }
            }
          }
        }
        .balance {
          color: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 160px;
          margin: 5px 0;
          letter-spacing: -0.2px;
          .name {
            font-size: 12px;
            margin-right: 5px;
            white-space: nowrap;
          }
          .coin {
            font-size: 12px;
            line-height: 20px;
            font-weight: 700;
            color: ${theme.colors.yellow};
            text-align: right;
            padding: 0;
            white-space: nowrap;
          }
        }
        .flex {
          align-items: center;
          display: flex;
        }
      }
    }
    &-deposit {
      margin: 0 24px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &-level {
      margin-right: 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      text-decoration: none;
      cursor: pointer;
      .username {
        display: block;
        max-width: 100px;
        line-height: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        transition: color 0.2s ease-out;
        font-weight: 500;
        text-decoration: none;
        color: white;
      }
      .inner {
        display: flex;
        align-items: center;
        .profile-loyalty-level {
          flex-shrink: 0;
          height: 18px;
          width: 18px;
          text-align: center;
          font-size: 10px;
          line-height: 19px;
          font-weight: 700;
          color: #000;
          white-space: nowrap;
          overflow: hidden;
          background-image: url(${StarIcon});
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          margin-right: 5px;
        }
        .profile-loyalty-bar {
          width: 80px;

          .ant-progress {
            &-text {
              display: none;
            }
            &-line {
              margin-bottom: unset;
            }
            &-outer {
              height: 8px !important;

              margin-inline-end: unset !important;
              padding-inline-end: unset !important;
            }
            &-inner {
              background-color: rgb(202, 202, 206);
              height: 100%;
            }
            &-bg {
              height: 100% !important;
              background: linear-gradient(180deg, #dd3023 0%, #90241e 100%);
            }
          }
        }
      }
      .achievement {
        font-size: 12px;
        margin: 0;
        text-decoration: none;
        color: white;
      }
    }
  }
`;
export default StyledHeaderIsVerified;
